import { ReactComponent as RemoveIcon } from '../../Common/BootstrapIcons/close.svg';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import InfoIcon from '../../Common/InfoIcon/InfoIcon';
import React from 'react';
import EditableText from '../../Common/EditableText/EditableText';
import Selector from '../../../types/report/Selector';
import ComponentType from '../../../types/report/ComponentType';
import ComponentChangeLogIconAndAction from '../../Common/Modals/ComponentChangeLogModal/ComponentChangeLogIconAndAction';
import CustomDropdown from '../../Common/Dropdown/CustomDropdown';
import CustomDropdownOption from '../../Common/Dropdown/CustomDropdownOption';

const referenceComponentTypes = [ComponentType.IsinSelector, ComponentType.LeiSelector, ComponentType.ExchangeRatesSelector];

const onValueChange = async (selector: Selector, e: any, onLockSectionClick: (e: any, number: number) => Promise<boolean>, isValidationConfig?: boolean, changeFunction?: (text: string, number: number, event: React.ChangeEvent<HTMLElement>) => void, value?: any) => {

    let isLocked = false;
    if (isValidationConfig && !selector.isUsedByCurrentUser) {
        if (selector.isLocked) {
            e.stopPropagation();
        }
        else if (isValidationConfig) {
            isLocked = await onLockSectionClick(e, selector.number);
            if (isLocked) {
                e.stopPropagation();
            }
            else if (changeFunction) {
                changeFunction(value, selector.number, e);
            }
        }
    }

    if (!isValidationConfig) {
        if (changeFunction) {
            changeFunction(value, selector.number, e);
        }
    }

    return isLocked;
}

const getColumns = (
    onLockSectionClick: (event: React.MouseEvent<HTMLElement> | React.ChangeEvent<HTMLElement> | React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>, number: number) => Promise<boolean>,
    onRemoveClick: (number: number, event: React.MouseEvent<HTMLElement>) => void,
    onNameChange: (name: string, number: number) => void,
    isReadOnly: boolean,
    info: string,
    selectorType: string,
    componentType: ComponentType,
    reportConfigId: number,
    getReferences: (number: number) => Promise<CustomDropdownOption[]>,
    onReferenceSelected: (option: CustomDropdownOption) => void,
    isValidationConfig?: boolean,
): ColumnDefinition<Selector>[] => {

    let columns: ColumnDefinition<Selector>[] = [
        {
            header: 'Info',
            getContent: x => <InfoIcon info={info} isSmallSize={true} />,
            width: '10%'
        },
        {
            header: 'Reference',
            getContent: x => x.number.toString(),
            width: '10%'
        },
        {
            header: 'Name',
            getContent: x => <EditableText disabled={x.isReadOnly || isReadOnly}
                onChange={async (value, e) => { return await onValueChange(x, e, onLockSectionClick, isValidationConfig, onNameChange, value) }}
                value={x.name}
                multiline={true} />,
            width: '30%'
        },
        {
            header: 'Data Type',
            getContent: x => selectorType,
            width: '20%'
        },
        {
            header: '',
            width: '30%',
            getContent: x =>
                <div className='display-flex justify-content-end'>
                    {referenceComponentTypes.includes(componentType) &&
                        <CustomDropdown
                            optionsPopupClassName='max-width-350px'
                            showOnlyDefaultTextAsSelected='References'
                            getOptions={() => { return getReferences(x.number) }}
                            value={x.name}
                            onOptionSelected={(option: CustomDropdownOption) => {
                                onReferenceSelected(option);
                            }}
                        />
                    }
                    <button
                        className="custom-icon-button float-right"
                        onClick={(event) => onRemoveClick(x.number, event)}
                        disabled={x.isReadOnly || isReadOnly}>
                        <CustomIcon icon={RemoveIcon} title={iconTooltip.remove} />
                    </button>

                    {x.id &&
                        <ComponentChangeLogIconAndAction
                            reportConfigId={reportConfigId}
                            id={x.id as number}
                            componentName={x.name}
                            componentType={componentType.toString()} />
                    }
                </div>
        }
    ];

    return columns;
};

export { getColumns };
